<template>
  <div id="container">
    <div class="headerLogin">
      <div>
        <img class="img" src="../../../static/image/login/logo.png" alt="" />
        <span class="span">注册</span>
      </div>
    </div>
    <div class="content">
      <div class="contentUser">
        <div class="contentLeft">
          <img
            class="img"
            src="../../../static/image/login/loginimg.png"
            alt=""
          />
        </div>
        <div class="contentRight">
          <div class="userlogin">用户注册</div>
          <div class="information">
            <div class="topone">

              <span class="leftCode"><span class="leftSpan">*</span>手机号</span>
              <input class="nameInput" maxlength="11" type="text" placeholder="请输入新手机号" v-model="phone"/>
              <button class="yzbuton" v-if="codeSuccess">{{ timeCount }}s后重新发</button>
              <button class="yzbuton" v-else @click="getCode">发送验证码</button>
            </div>
            <div class="line"></div>
            <div>
              <span class="leftCode"><span class="leftSpan">*</span>验证码</span>
              <input class="wordInput1" type="text" placeholder="请输入验证码" maxlength="6" v-model="captcha" />
            </div>
            <div class="line"></div>
            <div style="display: flex;align-items: center;">
              <span class="leftCode"><span class="leftSpan">*</span>密码</span>
              <input class="wordInput2" :type="pwdType" placeholder="请输入密码" v-model="password" />
              <img src="../../../static/image/canNotSee.png" alt="" v-if="pwdType=='password'" @click="changeType()">
              <img src="../../../static/image/canSeeNew.png" alt="" v-else  @click="changeType2()">
            </div>
            <div class="line"></div>
            <div style="display: flex;align-items: center;">
              <span class="leftCode"><span class="leftSpan">*</span>确认密码</span>
              <input class="wordInput3" :type="pwdType2" placeholder="请确认密码" v-model="password2" />
              <img src="../../../static/image/canNotSee.png" alt="" v-if="pwdType2=='password'" @click="changeType3()">
              <img src="../../../static/image/canSeeNew.png" alt="" v-else  @click="changeType4()">
            </div>
            <div class="line"></div>
            <div class="check">
              <span><span class="leftSpan">*</span>工作经验</span>
              　　<select selected class='checkedLevel' v-model="experience">
              　　　　
              <option :value="item.id" :key="item.id"  v-for="item in designTime">{{ item.name }}</option>
              　　</select>
            </div>
            <div class="line"></div>
            <div>
              <div class="ger"><span class="leftSpan">*</span>个人强项（可多选）</div>
              <div class="gerTab">
                <div
                  class="gerTr"
                  :class="selectStrengths.indexOf(item.id)>-1 ? 'gerTrs' : ''"
                  v-for="(item, index) in strengthsList"
                  @click="showTab(item)"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <button class="saveBtn" @click="sureRegister">确定</button>
            <div @click="goLogin" style="font-size: 12px;text-align: center;margin-top:10px;"><span>账号登录</span></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部展示区域 -->
    <div class="footerDiv">
      <BottomRegion class="footerForm" ref="bottomForm"></BottomRegion>
    </div>
  </div>
</template>

<script>
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示


export default {
  name: "forgetPassword",
  components: {
    BottomRegion,
  },
  data() {
    return {
      pwdType:'password',
      pwdType2:'password',
      userName: "",
      codeLogin: false,
      passwordLogin: false,
      designTime: [
        {
          id: '',
          name: '请选择'
        },
        {
          id: '1',
          name: '0-3年(包含3年)'
        },
        {
          id: '2',
          name: '3-5年(包含5年)'
        },
        {
          id: '3',
          name: '5-8年(包含8年)'
        },
        {
          id: '4',
          name: '8年以上'
        },
      ],
      strengthsList: [],
      selectStrengths: [],
      showIndex: 0,
      experience: '',
      phone: "",
      captcha: "",
      password: "",
      password2: "",
      codeSuccess: false,
      timeCount: 60,
    };
  },
  created() {
    this.getStrengthsList();
  },
  methods: {
    // blurChange(e){
    //   if(e.target.value.length<6 || e.target.value.length>20){
    //     this.$message('密码长度限定6到20位')
    //   }
    // },
    // blurChange2(e){
    //   if(e.target.value.length<6 || e.target.value.length>20){
    //     this.$message('密码长度限定6到20位')
    //   }
    // },
    changeType(){
      this.pwdType = 'text'
    },
    changeType2(){
      this.pwdType = 'password'
    },
    changeType3(){
      this.pwdType2 = 'text'
    },
    changeType4(){
      this.pwdType2 = 'password'
    },
    goLogin(){
      this.$router.push({path: '/login/login'})
    },
    //发送验证码
    async getCode() {
      if (!this.phone || this.codeSuccess) {
        return false;
      }
      if (!(/^1[3|4|5|8|7|6|9][0-9]\d{8}$/.test(this.phone))) {
        this.$message('请输入正确手机号码');
        return false;
      }
      let data = {
        phone: this.phone,
        smsMode: 1
      }
      try {
        const res = await this.$http.designerSms(data)
        console.log(res)
        if (res.code == 200) {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          });
          this.codeSuccess = true;
          this.timeCount = 60;
          let timer = setInterval(() => {
            if (this.timeCount <= 0) {
              clearInterval(timer);
              this.codeSuccess = false;
              this.timeCount = 60;
            } else {
              this.timeCount--;
            }
          }, 1000)
        } else {
          this.$message(res.message);
        }
      } catch (e) {
        throw e
      }
    },
    async sureRegister() {

      if (this.phone=='' || this.phone==null) {
        this.$message.warning('请输入手机号');
        return false;
      }
      if (this.captcha=='' || this.captcha==null) {
        this.$message.warning('请输入验证码');
        return false;
      }
      let reg = /^[a-zA-z0-9]{6,20}$/
      if (!reg.test(this.password)) {
        this.$message.warning('密码位数限定6到20位的数字或字母')
        return false
      }
      if (this.password != this.password2) {
        this.$message.warning('两次输入的密码不一致');
        return false;
      }
      if (this.experience=='' || this.experience=='') {
        this.$message.warning('请选择工作经验');
        return false;
      }
      if (this.selectStrengths.length<=0) {
        this.$message.warning('请选择个人强项');
        return false;
      }

      try {
        let list = [...this.selectStrengths];
        let id = sessionStorage.getItem('channelId')
         let data = {}
        if(id!=null){
          data = {
            phone: this.phone,
            captcha: this.captcha,
            experience: this.experience,
            password: this.password,
            strengths: list.join(","),
            channelId:id
          }
        }else{
           data = {
            phone: this.phone,
            captcha: this.captcha,
            experience: this.experience,
            password: this.password,
            strengths: list.join(","),
          }
        }

        const res = await this.$http.designerRegister(data);
        if (res.code == 200) {
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.push({path: '/login/login'})
        } else {
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
    async getStrengthsList() {
      try {
        let data = {}
        const res = await this.$http.strengthsList(data);
        if (res.code == 200) {
          this.strengthsList = res.result;
        } else {
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
    showTab(item) {
      // this.showIndex = item.index;
      // item.status = !item.status;
      if (this.selectStrengths.indexOf(item.id) == -1) {
        this.selectStrengths.push(item.id);
      } else {
        let index = this.selectStrengths.indexOf(item.id);
        this.selectStrengths.splice(index, 1);
      }
    },
    codeLoginClick() {
      this.codeLogin = true;
      this.passwordLogin = true;
    },
    register() {
      this.$router.push({
        name: "register",
      });
      console.log("llll");
    },
    forgetPassword() {
      console.log("oooo");
    },
    login() {
      console.log("login");
    },
    messageCode() {
      this.$router.push({name: "loginNumber"});
      console.log("messageCode");
    },
  },
};
</script>

<style lang='less' scoped>
.check {
  margin-left: 53px;
  margin-top: 8px;
  font-size: 14px;
  color: #3A3A3A;
}

.input{
  width:200px;
  height:30px;
  background: red;
  border:1px solid grey;
}
.input:empty::before{
  color:lightgrey;
  content:attr(placeholder);
}

.checkedLevel {
  margin-left: 10px;
  width: 120px;
  height: 26px;
  border: 1px solid #ECECEC;
 color: #3A3A3A;
font-size: 13px;
  outline: 1px solid #ECECEC;
}

.ger {
  margin-left: 53px;
  margin-top: 8px;
  font-size: 13px;
color: #3A3A3A;;
}

.gerTab {
  padding: 0 0 0 33px;
}

.gerTr {
  padding: 0 10px;
  height: 20px;
  border: 1px solid #707070;
  border-radius: 3px;
  cursor: pointer;
  font-size: 10px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  margin-top: 14px;
  margin-left: 9px;
  color: #3A3A3A;
  font-size: 12px;
  content: attr(placeholder);
}
.gerTr:empty::before{
  color:black;
  content:attr(placeholder);
}

.gerTrs {
  border: solid 1px #dfb876;
  color: #dfb876;
}

.headerLogin {
  width: 100%;
  height: 100px;

    .img {
      margin-left: 379px;
      margin-top: 24px;
    }

    .span {
      position: relative;
      top: -12px;
      margin-left: 27px;
      width: 104px;
      height: 30px;
      font-size: 25px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
    }

}

.content {
  width: 100%;
  height: 689px;
  background-image: url("../../../static/image/login/back.png") !important;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* // background: red; */
  display: flex;
  justify-content: center;
}

.contentUser {
  display: inline-block;
  width: 777px;
  height: 486px;
  margin-top: 90px;
  background-color: mediumpurple;
  /* margin-left: 572px; */

  .contentLeft {
    float: left;
    width: 361px;
    height: 486px;
    .img {
      width: 361px;
      height: 486px;
    }
  }

  .contentRight {
    background-color: #ffffff;
    float: right;
    width: 416px;
    height: 486px;

    .saveBtn {
      width: 230px;
      height: 39px;
      border-radius: 20px;
      background-color: #dfb876;
      margin-left: 96px;
      margin-top: 20px;
      color: #fff;
      font-size: 15px;
      border: none;
      outline: none;
    }

    .userlogin {
      margin-left: 144px;
      margin-top: 30px;
      width: 104px;
      height: 36px;
      font-size: 25px;
      font-weight: bold;
      line-height: 31px;
      font-size: 25px;
      color: #333333;
    }

    .information {
      /* background-color: pink; */
      margin-top: 25px;
      img{
        width: 30px;
       margin-top: 8px;
      }
      .topone {
        /*margin-top: 26px;*/
        /* display: flex;
        align-items: center; */
      }

      .leftCode {
        color: #3A3A3A;
        font-size: 14px;
        margin-left: 53px;
        margin-top: 6px;
      }

      .line {
        height: 2px;
        width: 345px;
        height: 0px;
        border-bottom: 1px solid #f2f6fc;
        // background: #B2B2B2;
        margin-left: 54px;
        margin-top: 8px;
      }

      .yzbuton {
        position: relative;
        left: 25px;
        display: inline;
        width: 90px;
        height: 26px;
        background: #ffffff;
        border: 1px solid #dfb876;
       font-size: 12px;
        border-radius: 5px;
        color: #DFB876;
        outline: none;
      }

      .nameInput {
        border: none;
        height: 20px;
        padding-left: 28px;
        width: 135px;
        font-size: 13px;
        color: #C7C7C7;
      }

      .nameInput:focus {
        border: none;
        outline: none;
      }

      .wordInput1 {
        margin-top: 8px;
        padding-left: 28px;
        border: none;
        height: 20px;
      }

      .wordInput1:focus {
        border: none;
        outline: none;
      }
      .wordInput2 {
        margin-top: 8px;
        padding-left: 45px;
        border: none;
        height: 20px;
      }

      .wordInput2:focus {
        border: none;
        outline: none;
      }
      .wordInput3 {
        margin-top: 8px;
        padding-left: 17px;
        border: none;
        height: 20px;
      }

      .wordInput3:focus {
        border: none;
        outline: none;
      }

      .btn {
        .buttons {
          width: 268px;
          height: 48px;
          border-radius: 20px;
          margin-left: 65px;
          margin-top: 20px;
        }
      }

      .code {
        margin-left: 152px;
        margin-top: 10px;
      }
    }
  }
}

.leftSpan{
  margin-right: 5px;
  color: #E76168;
}
input:-internal-autofill-selected {
  -webkit-text-fill-color: #303133 !important;
  transition: background-color 5000s ease-in-out 0s !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/register.vue